import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ax/Button";
import { PrimaryBar } from "@/components/ax/PrimaryBar";
import { useI18n } from "@/i18n";
import { auth } from "@/lib/firebase";
import { fmtDate, syncSubscriptionFromFirestore } from "@/lib/subscription";
import { subscriptionPresentation } from "@/lib/subscriptionPresentation";

export default function LanggananHasil() {
  const { t, lang } = useI18n();
  const navigate = useNavigate();
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setSub(null);
    syncSubscriptionFromFirestore(auth.currentUser?.uid)
      .then((latest) => { if (alive) { setSub(latest); setNow(Date.now()); } })
      .catch(() => { if (alive) setSub(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [retry]);

  const view = subscriptionPresentation(sub, now);
  useEffect(() => {
    const remaining = view.endsAt ? new Date(view.endsAt).getTime() - Date.now() : NaN;
    if (!(remaining > 0)) return undefined;
    const timer = setTimeout(() => setNow(Date.now()), Math.min(remaining + 1, 2147483647));
    return () => clearTimeout(timer);
  }, [view.endsAt, now]);

  return (
    <div data-testid="plan-result-page">
      <h1 className="type-h1">{t("plan.accessTitle")}</h1>
      <p className="mt-3 text-base leading-6 text-ax-text-2" data-testid="plan-result-note">{t("plan.resultNote")}</p>
      {loading ? <p role="status" className="mt-3 text-sm text-ax-muted">{t("acc.accessLoading")}</p> :
        !sub ? <div className="mt-3" data-testid="plan-result-unconfirmed"><p role="alert" className="text-sm leading-5 text-ax-error">{t("plan.unconfirmed")}</p><Button variant="ghost" onClick={() => setRetry((n) => n + 1)}>{t("retry")}</Button></div> :
        <div className="mt-3" data-testid="plan-result-verified">
          <p className="m-0 text-base font-medium text-ax-text" data-testid="result-status">{t(view.labelKey)}</p>
          <p className="mt-2 text-base leading-6 text-ax-text-2">{t(view.noticeKey)}</p>
          {view.endsAt && <p className="mt-2 font-mono text-[13px] leading-5 text-ax-text" data-testid="result-date">{t(view.dateKey)}: {fmtDate(lang, view.endsAt)}</p>}
        </div>}
      <p className="mt-4 text-sm leading-5 text-ax-muted">{t("plan.paymentNotice")}</p>
      <PrimaryBar>
        <Button
          variant="primary"
          onClick={() => navigate("/akun")}
          data-testid="result-primary-button"
          className="w-full md:w-auto md:min-w-[200px]"
        >
          {t("plan.toAccount")}
        </Button>
      </PrimaryBar>
    </div>
  );
}
